import BaseService from './Base';
import ConfigService from './Config';

class DynamicFormDataService extends BaseService {
  static endpoint = 'api/2.0/dynamic-forms-data/';

  static createTrigger = async (data, params, skipLoading = false) => {
    const url = ConfigService.generateURL(this.endpoint + 'triggers/create/', params);
    if (!skipLoading && ConfigService.contextApi) {
      ConfigService.contextApi.setLoading(true);
    }
    try {
      const response = await window.fetch(url, {
        method: 'POST',
        body: JSON.stringify(data),
        headers: {
          Accept: 'application/json, text/plain, */*',
          Authorization: 'jwt ' + localStorage.getItem('jwt_token'),
          'Content-Type': 'application/json;charset=UTF-8',
          'Time-Zone': jstz.determine().name()
        }
      });
      const JSONresponse = await response.json();
      if (!skipLoading && ConfigService.contextApi) {
        ConfigService.contextApi.setLoading(false);
      }
      return JSONresponse;
    } catch (e) {
      if (!skipLoading && ConfigService.contextApi) {
        ConfigService.contextApi.setLoading(false);
      }
      return null;
    }
  };

  static updateTrigger = async (data, params, skipLoading = false) => {
    const url = ConfigService.generateURL(this.endpoint + 'triggers/update/', params);
    if (!skipLoading && ConfigService.contextApi) {
      ConfigService.contextApi.setLoading(true);
    }
    try {
      const response = await window.fetch(url, {
        method: 'PATCH',
        body: JSON.stringify(data),
        headers: {
          Accept: 'application/json, text/plain, */*',
          Authorization: 'jwt ' + localStorage.getItem('jwt_token'),
          'Content-Type': 'application/json;charset=UTF-8',
          'Time-Zone': jstz.determine().name()
        }
      });
      const JSONresponse = await response.json();
      if (!skipLoading && ConfigService.contextApi) {
        ConfigService.contextApi.setLoading(false);
      }
      return JSONresponse;
    } catch (e) {
      if (!skipLoading && ConfigService.contextApi) {
        ConfigService.contextApi.setLoading(false);
      }
      return null;
    }
  };

  static removeTrigger = async (params, skipLoading = false) => {
    const url = ConfigService.generateURL(this.endpoint + 'triggers/delete/', params);
    if (!skipLoading && ConfigService.contextApi) {
      ConfigService.contextApi.setLoading(true);
    }
    try {
      const response = await window.fetch(url, {
        method: 'DELETE',
        headers: {
          Authorization: 'jwt ' + localStorage.getItem('jwt_token'),
          'Time-Zone': jstz.determine().name()
        }
      });
      const JSONresponse = await response.json();
      if (!skipLoading && ConfigService.contextApi) {
        ConfigService.contextApi.setLoading(false);
      }
      return JSONresponse;
    } catch (e) {
      if (!skipLoading && ConfigService.contextApi) {
        ConfigService.contextApi.setLoading(false);
      }
      return null;
    }
  };
}

export default DynamicFormDataService;